import React, { useState, useEffect } from "react";
import { useLanguage } from "@/App";
import { Cookie, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const CookieBanner = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("eg_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("eg_cookie_consent", "all");
    setIsVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem("eg_cookie_consent", "essential");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          data-testid="cookie-banner"
          className="fixed bottom-0 left-0 right-0 z-[60] p-4 md:p-6"
        >
          <div className="max-w-4xl mx-auto bg-[#0A0A0A] border border-white/10 p-6 md:p-8 shadow-2xl backdrop-blur-xl">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#FF6B00]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Cookie size={20} className="text-[#FF6B00]" />
              </div>
              <div className="flex-grow">
                <h3 className="text-white font-bold text-lg mb-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
                  {language === "nl" ? "Wij gebruiken cookies" : "We use cookies"}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed mb-4">
                  {language === "nl"
                    ? "Wij gebruiken cookies om je ervaring op onze website te verbeteren, verkeer te analyseren en gepersonaliseerde content te tonen. Lees ons "
                    : "We use cookies to improve your experience, analyze traffic, and show personalized content. Read our "}
                  <a href="/cookies" className="text-[#FF6B00] hover:underline">
                    {language === "nl" ? "cookiebeleid" : "cookie policy"}
                  </a>
                  {language === "nl" ? " voor meer informatie." : " for more information."}
                </p>
                <div className="flex flex-wrap gap-3">
                  <button
                    onClick={acceptAll}
                    data-testid="cookie-accept-all"
                    className="bg-[#FF6B00] text-white px-6 py-2.5 text-sm font-bold hover:bg-[#FF6B00]/90 transition-all"
                  >
                    {language === "nl" ? "Alles Accepteren" : "Accept All"}
                  </button>
                  <button
                    onClick={acceptEssential}
                    data-testid="cookie-accept-essential"
                    className="bg-white/5 text-white border border-white/10 px-6 py-2.5 text-sm font-bold hover:bg-white/10 transition-all"
                  >
                    {language === "nl" ? "Alleen Noodzakelijk" : "Essential Only"}
                  </button>
                </div>
              </div>
              <button
                onClick={acceptEssential}
                className="text-zinc-500 hover:text-white transition-colors flex-shrink-0"
              >
                <X size={20} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
